import React from 'react'
import "./Contact.css";
import Footer from '../Footer';
const Contact1 = () => {
  return (
    <div>
      {/* <div className='border1 rounded-3'>
    <div class="wrapper rounded-3">
    <form class="form border1">
      <div class="pageTitle title">Contact Us </div>
      <div class="secondaryTitle title">Please free to ping a message</div>
      <input type="text" class="name formEntry" placeholder="Name" />
      <input type="text" class="email formEntry" placeholder="Email"/>
      <textarea class="message formEntry" placeholder="Message"></textarea>
      <input type="checkbox" class="termsConditions" value="Term"/>
      <label style={{color: "grey"}} for="terms"> I Accept the <span style={{color: "#0e3721"}}>Terms of Use</span> & <span style={{color: "#0e3721"}}>Privacy Policy</span>.</label><br/>
      <button class="submit formEntry" onclick="thanks()">Submit</button>
    </form>
  </div>
    </div> */}
    <div className='div1'>
    <section>
    
    <div class="section-header">
      <div class="container">
        <h2>Contact Us</h2>
        <p>We offer unique and adventurous safari tours, providing a glimpse of wildlife and the natural beauty of Uganda.</p>
      </div>
    </div>
    
    <div class="container-fluid">
      <div class="row">
        
        <div class="contact-info col-6 m-0">
          <div class="contact-info-item">
            <div class=" ">
              <i class="fas fa-home "></i>
            </div>
            
            <div class="contact-info-content ">
              <h4>Address</h4>
              <p>Central Kampala, Nakawa, Sentamu Kavule A. <br/></p>
            </div>
          </div>
          
          <div class="contact-info-item">
            <div class="">
              <i class="fas fa-phone"></i>
            </div>
            
            <div class="contact-info-content">
              <h4>Phone</h4>
              <p>+256763000338<br/>+971558293775<br/>+971551579904</p>
            </div>
          </div>
          
          <div class="contact-info-item">
            <div class="">
              <i class="fas fa-envelope"></i>
            </div>
            
            <div class="contact-info-content ">
              <h4>Email</h4>
             <p>info@japlandtours.com</p>
            </div>
          </div>
        </div>
        
        <div class="contact-form col-6">
          <form action="" id="contact-form">
            <h2>Send Message</h2>
            <div class="input-box">
              <input type="text" required="true" name=""/>
              <span>Full Name</span>
            </div>
            
            <div class="input-box">
              <input type="email" required="true" name=""/>
              <span>Email</span>
            </div>
            
            <div class="input-box">
              <textarea required="true" name=""></textarea>
              <span>Type your Message...</span>
            </div>
            
            <div class="input-box">
              <input type="submit" value="Send" name=""/>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  </section>
    </div>
  
    </div>
  )
}

export default Contact1
